import { useRef, useState, useEffect } from 'react'
import { motion, useScroll, useTransform } from 'framer-motion'
import carImgL from '../images/Parallax3_L.webp'
import carImgM from '../images/Parallax3_M.webp'
import carImgS from '../images/Parallax3_S.webp'
import { CarContainer } from './styled'
const Car = () => {
  const ref = useRef(null)
  const [isDesktop, setIsDesktop] = useState<boolean>(false)
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ['end end', 'start start'],
  })

  const moveX = useTransform(
    scrollYProgress,
    [0, 0.5, 1],
    ['-50vw', '0vw', '0vw']
  )
  const moveY = useTransform(
    scrollYProgress,
    [0, 0.5, 1],
    ['50vw', '0vw', '0vw']
  )
  const opacity = useTransform(scrollYProgress, [0, 0.5, 1], ['0', '1', '1'])
  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth > 1024)
    }

    handleResize() // set initial value
    window.addEventListener('resize', handleResize)

    return () => window.removeEventListener('resize', handleResize)
  })

  return (
    <CarContainer ref={ref}>
      <motion.div
        style={{
          translateX: !isDesktop ? moveX : '0vw',
          translateY: !isDesktop ? moveY : '0vw',
          opacity: !isDesktop ? opacity : '1',
        }}
      >
        <picture>
          <source
            srcSet={carImgS}
            media="(max-width: 1024px)"
            type="image/webp"
          />
          <source
            srcSet={carImgM}
            media="(max-width: 1280px)"
            type="image/webp"
          />
          <img src={carImgL} alt="car" />
        </picture>
      </motion.div>
    </CarContainer>
  )
}
export default Car
